/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React, { useMemo } from "react";
import Table from "./SummaryTable";
import tableStyle from "../../../../../theme/styles/table";
import styles from "./FriendSummaryReportTable.styles";
import Typography from "../../../../../components/common/new/Typography/Typography";

const tableCellWidth = {
  tiny: { maxWidth: "3.5rem" },
  small: { maxWidth: "6rem" },
  medium: { maxWidth: "10rem" },
};

const DEFAULT_COLUMNS = [
  { displayName: "-", key: "hierarchy" },
  { displayName: "MD", key: "friendMdCount" },
  { displayName: "WD", key: "friendWdCount" },
  { displayName: "YMD SD", key: "friendYmdSdCount" },
  { displayName: "YMD Non-SD", key: "friendYmdCount" },
  { displayName: "YMD Total", key: "friendYmdTotal" },
  { displayName: "YWD SD", key: "friendYwdSdCount" },
  { displayName: "YWD Non-SD", key: "friendYwdCount" },
  { displayName: "YWD Total", key: "friendYwdTotal" },
  { displayName: "FDB Cubs", key: "friendFdbCbCount" },
  { displayName: "FDB YP", key: "friendFdbYpbCount" },
  { displayName: "FDB YL", key: "friendFdbYlbCount" },
  { displayName: "FDB Total", key: "friendFdbTotal" },
  { displayName: "FDG Cubs", key: "friendFdgCgCount" },
  { displayName: "FDG YP", key: "friendFdgYpgCount" },
  { displayName: "FDG YL", key: "friendFdgYlgCount" },
  { displayName: "FDG Total", key: "friendFdgTotal" },
  { displayName: "Total", key: "totalFriendCount" },
];

const renderRow = (item, index) => {
  // Compute totals from the breakdown fields
  const ymdTotal = (item.friendYmdCount || 0) + (item.friendYmdSdCount || 0);
  const ywdTotal = (item.friendYwdCount || 0) + (item.friendYwdSdCount || 0);
  const fdbTotal =
    (item.friendFdbCbCount || 0) +
    (item.friendFdbYpbCount || 0) +
    (item.friendFdbYlbCount || 0);
  const fdgTotal =
    (item.friendFdgCgCount || 0) +
    (item.friendFdgYpgCount || 0) +
    (item.friendFdgYlgCount || 0);

  // For the overall total, use the API-provided value if it exists;
  // otherwise, compute the sum from the breakdown.
  const allTotal =
    item.totalFriendCount !== undefined
      ? item.totalFriendCount
      : (item.friendMdCount || 0) +
        (item.friendWdCount || 0) +
        ymdTotal +
        ywdTotal +
        fdbTotal +
        fdgTotal;

  return (
    <TableRow style={tableStyle.tableRow} key={index}>
      {/* Structure Name */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.structureName}
        </Typography>
      </TableCell>
      {/* MD */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendMdCount}
        </Typography>
      </TableCell>
      {/* WD */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendWdCount}
        </Typography>
      </TableCell>
      {/* YMD SD */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendYmdSdCount}
        </Typography>
      </TableCell>
      {/* YMD Non-SD */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendYmdCount}
        </Typography>
      </TableCell>
      {/* YMD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>{ymdTotal}</Typography>
      </TableCell>
      {/* YWD SD */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendYwdSdCount}
        </Typography>
      </TableCell>
      {/* YWD Non-SD */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendYwdCount}
        </Typography>
      </TableCell>
      {/* YWD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>{ywdTotal}</Typography>
      </TableCell>
      {/* FDB Cubs */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendFdbCbCount}
        </Typography>
      </TableCell>
      {/* FDB YP */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendFdbYpbCount}
        </Typography>
      </TableCell>
      {/* FDB YL */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendFdbYlbCount}
        </Typography>
      </TableCell>
      {/* FDB Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>{fdbTotal}</Typography>
      </TableCell>
      {/* FDG Cubs */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendFdgCgCount}
        </Typography>
      </TableCell>
      {/* FDG YP */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendFdgYpgCount}
        </Typography>
      </TableCell>
      {/* FDG YL */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          {item.friendFdgYlgCount}
        </Typography>
      </TableCell>
      {/* FDG Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>{fdgTotal}</Typography>
      </TableCell>
      {/* Overall Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>{allTotal}</Typography>
      </TableCell>
    </TableRow>
  );
};

const getGrandTotalRow = (data) => {
  const grandTotals = {
    friendMdCount: 0,
    friendWdCount: 0,
    friendYmdSdCount: 0,
    friendYmdCount: 0,
    friendYwdSdCount: 0,
    friendYwdCount: 0,
    friendFdbCbCount: 0,
    friendFdbYpbCount: 0,
    friendFdbYlbCount: 0,
    friendFdgCgCount: 0,
    friendFdgYpgCount: 0,
    friendFdgYlgCount: 0,
    totalFriendCount: 0,
  };

  data.forEach((item) => {
    const md = item.friendMdCount || 0;
    const wd = item.friendWdCount || 0;
    const ymdSD = item.friendYmdSdCount || 0;
    const ymdNonSD = item.friendYmdCount || 0;
    const ymdTotal = ymdSD + ymdNonSD;
    const ywdSD = item.friendYwdSdCount || 0;
    const ywdNonSD = item.friendYwdCount || 0;
    const ywdTotal = ywdSD + ywdNonSD;
    const fdbCb = item.friendFdbCbCount || 0;
    const fdbYpb = item.friendFdbYpbCount || 0;
    const fdbYlb = item.friendFdbYlbCount || 0;
    const fdbTotal = fdbCb + fdbYpb + fdbYlb;
    const fdgCg = item.friendFdgCgCount || 0;
    const fdgYpg = item.friendFdgYpgCount || 0;
    const fdgYlg = item.friendFdgYlgCount || 0;
    const fdgTotal = fdgCg + fdgYpg + fdgYlg;
    const overallTotal =
      item.totalFriendCount !== undefined
        ? item.totalFriendCount
        : md + wd + ymdTotal + ywdTotal + fdbTotal + fdgTotal;

    grandTotals.friendMdCount += md;
    grandTotals.friendWdCount += wd;
    grandTotals.friendYmdSdCount += ymdSD;
    grandTotals.friendYmdCount += ymdNonSD;
    grandTotals.friendYwdSdCount += ywdSD;
    grandTotals.friendYwdCount += ywdNonSD;
    grandTotals.friendFdbCbCount += fdbCb;
    grandTotals.friendFdbYpbCount += fdbYpb;
    grandTotals.friendFdbYlbCount += fdbYlb;
    grandTotals.friendFdgCgCount += fdgCg;
    grandTotals.friendFdgYpgCount += fdgYpg;
    grandTotals.friendFdgYlgCount += fdgYlg;
    grandTotals.totalFriendCount += overallTotal;
  });

  const grandYmdTotal =
    grandTotals.friendYmdSdCount + grandTotals.friendYmdCount;
  const grandYwdTotal =
    grandTotals.friendYwdSdCount + grandTotals.friendYwdCount;
  const grandFdbTotal =
    grandTotals.friendFdbCbCount +
    grandTotals.friendFdbYpbCount +
    grandTotals.friendFdbYlbCount;
  const grandFdgTotal =
    grandTotals.friendFdgCgCount +
    grandTotals.friendFdgYpgCount +
    grandTotals.friendFdgYlgCount;

  return (
    <TableRow style={tableStyle.tableRow} key="grand-total">
      {/* Chapter cell for totals */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>Total</strong>
        </Typography>
      </TableCell>
      {/* MD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendMdCount}</strong>
        </Typography>
      </TableCell>
      {/* WD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendWdCount}</strong>
        </Typography>
      </TableCell>
      {/* YMD SD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendYmdSdCount}</strong>
        </Typography>
      </TableCell>
      {/* YMD Non‑SD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendYmdCount}</strong>
        </Typography>
      </TableCell>
      {/* YMD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandYmdTotal}</strong>
        </Typography>
      </TableCell>
      {/* YWD SD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendYwdSdCount}</strong>
        </Typography>
      </TableCell>
      {/* YWD Non‑SD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendYwdCount}</strong>
        </Typography>
      </TableCell>
      {/* YWD Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandYwdTotal}</strong>
        </Typography>
      </TableCell>
      {/* FDB Cubs Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendFdbCbCount}</strong>
        </Typography>
      </TableCell>
      {/* FDB YP Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendFdbYpbCount}</strong>
        </Typography>
      </TableCell>
      {/* FDB YL Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendFdbYlbCount}</strong>
        </Typography>
      </TableCell>
      {/* FDB Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandFdbTotal}</strong>
        </Typography>
      </TableCell>
      {/* FDG Cubs Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendFdgCgCount}</strong>
        </Typography>
      </TableCell>
      {/* FDG YP Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendFdgYpgCount}</strong>
        </Typography>
      </TableCell>
      {/* FDG YL Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.friendFdgYlgCount}</strong>
        </Typography>
      </TableCell>
      {/* FDG Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandFdgTotal}</strong>
        </Typography>
      </TableCell>
      {/* Overall Total */}
      <TableCell style={tableCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>{grandTotals.totalFriendCount}</strong>
        </Typography>
      </TableCell>
    </TableRow>
  );
};

function ReportTable({ searchData }) {
  const reportTableColumns = useMemo(() => {
    if (searchData && searchData.length > 0 && searchData[0].hierarchy) {
      const updatedColumns = [...DEFAULT_COLUMNS];
      updatedColumns[0] = {
        ...updatedColumns[0],
        displayName: searchData[0].hierarchy,
      };
      return updatedColumns;
    }
    return DEFAULT_COLUMNS;
  }, [searchData]);

  const rows = useMemo(() => {
    if (!searchData || searchData.length === 0) return null;
    const dataRows = searchData.map((item, index) => renderRow(item, index));
    dataRows.push(getGrandTotalRow(searchData));
    return dataRows;
  }, [searchData]);

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={reportTableColumns}
        rows={rows}
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "left",
        }}
        searchData={searchData}
      />
    </div>
  );
}

export default ReportTable;
